import { GpcMonitor } from './gpcMonitor';

const props = [];

export const GpcMonitorDirective = reactDirective => reactDirective(GpcMonitor, props);
    GpcMonitorDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('gpcMonitor', GpcMonitorDirective);
